import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    
 } from 'Actions';

class GolfItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:'', 
            loader:false,
            
        };
    }


render() {

    const { playerinterventionlist, loading} = this.props;
    var totinvert=0; 
    if(playerinterventionlist.length!=0){
        var totinvert=playerinterventionlist.range.total+playerinterventionlist.course.total;
    }

      return(
        <div>
                    <div className="row">
                        <div className="col-sm-6 col-lg-2"><button className="mr-3 mb-3 btn btn-outline-primary" onClick={() =>this.props.onClick(1)}> INTERVENTIONS</button> <span className="text-center">Total : <strong>{totinvert}</strong> </span></div>
                        <div className="col-sm-6 col-lg-2"><button className="mr-3 mb-3 btn btn-outline-primary" onClick={() =>this.props.onClick(2)}> PRACTICE SCHEDULE</button> <span className="text-center">Total : <strong>1</strong> </span> </div>
                        <div className="col-sm-6 col-lg-2"><button className="mr-3 mb-3 btn btn-outline-primary" onClick={() =>this.props.onClick(3)}> ON RANGE TESTS</button> <span className="text-center">Total : <strong>{playerinterventionlist.onrangetest.total}</strong> </span></div>
                        <div className="col-sm-6 col-lg-2"><button className="mr-3 mb-3 btn btn-outline-primary" onClick={() =>this.props.onClick(4)}> ON COURSE TESTS</button> <span className="text-center">Total : <strong>{playerinterventionlist.oncoursetest.total}</strong> </span></div>
                        <div className="col-sm-6 col-lg-2"><button className="mr-3 mb-3 btn btn-outline-primary" onClick={() =>this.props.onClick(5)}> TOURNAMENT DATA</button> <span className="text-center">Total : <strong>{playerinterventionlist.tournament.total}</strong> </span></div>
                        <div className="col-sm-6 col-lg-2"><button className="mr-3 mb-3 btn btn-outline-primary" onClick={() =>this.props.onClick(6)}> TECHNOLOGY REPORTS</button> <span className="text-center">Total : <strong>{playerinterventionlist.technology.total}</strong> </span></div> 
                        <div className="col-sm-12 col-lg-12" style={{margin:"10px", borderTop:"3px solid rgb(64 64 63)", borderBottom:"3px solid rgb(64 64 63)"}}>
                            <h2 className="text-center" style={{marginTop:"5px"}}>TOURNAMENT STATS</h2>
                        </div>
                        <div className="col-sm-12 col-lg-12" style={{height:"200px"}}>

                        </div>
                    </div>
                    

                    {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                    }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
    
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    
})(GolfItems);
